// plugins/drawing/index.ts

import type { PluginDefinition } from "../types";
import { AOIPluginComponent } from "./AOIPlugin";

export const AOIPlugin: PluginDefinition = {
  id: "aoi",
  Component: AOIPluginComponent,
};
